import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { supabase } from '../lib/supabase'

export default function CampaignNew() {
  const [name, setName] = useState('')
  const [office, setOffice] = useState('')
  const [county, setCounty] = useState('')
  const [state, setState] = useState('')
  const [saving, setSaving] = useState(false)
  const [err, setErr] = useState<string | null>(null)
  const navigate = useNavigate()

  const save = async () => {
    setErr(null); setSaving(true)
    const { data: sess } = await supabase.auth.getSession()
    const uid = sess?.session?.user?.id
    if (!uid) { setErr('Not signed in'); setSaving(false); return }

    // 1) create campaign
    const { data: camp, error: cErr } = await supabase
      .from('campaigns')
      .insert([{ name, office, county, state, created_by: uid }])
      .select('id')
      .single()
    if (cErr) { setErr(cErr.message); setSaving(false); return }

    // 2) link creator as admin
    const { error: uErr } = await supabase
      .from('campaign_users')
      .insert([{ campaign_id: camp!.id, user_id: uid, role: 'admin' }])
    if (uErr) { setErr(uErr.message); setSaving(false); return }

    navigate('/campaigns', { replace: true })
  }

  return (
    <div style={{ maxWidth: 520 }}>
      <h1>New Campaign</h1>
      <div style={{ display:'grid', gap:8 }}>
        <label>Name</label>
        <input value={name} onChange={e=>setName(e.target.value)} placeholder="Demo Campaign" />

        <label>Office</label>
        <input value={office} onChange={e=>setOffice(e.target.value)} placeholder="Mayor, City of McAllen" />

        <div style={{ display:'flex', gap:12 }}>
          <div style={{ flex: 1 }}>
            <label>County</label>
            <input value={county} onChange={e=>setCounty(e.target.value)} placeholder="Hidalgo" />
          </div>
          <div style={{ width:120 }}>
            <label>State</label>
            <input value={state} onChange={e=>setState(e.target.value)} placeholder="TX" />
          </div>
        </div>

        {err && <div style={{ color:'crimson' }}>{err}</div>}
        <div style={{ marginTop:8, display:'flex', gap:8 }}>
          <button onClick={save} disabled={saving || !name}>Create</button>
          <button onClick={()=>history.back()} disabled={saving}>Cancel</button>
        </div>
      </div>
    </div>
  )
}
